module.exports = __webpack_public_path__ + "49dafffe8161a5b0aa5ee3556059035b.eot";


//////////////////
// WEBPACK FOOTER
// ./app/assets/fonts/MyriadPro-Regular.eot
// module id = 165
// module chunks = 0